import React from "react";
import FuneralLandingPage from "@/pages/FuneralLandingPage";

const SYDNEY_PACKAGES = [
  {
    name: "The Farewell",
    price: 900,
    highlight: false,
    tagline: "Simple, reliable livestream for family and friends who cannot attend.",
    features: [
      "2 professional cameras",
      "Full funeral service livestream",
      "Live stream to a secure viewing page",
      "Up to 1 hour",
      "Professional audio from the venue",
      "Basic live production",
      "Recording of the livestream",
      "Tribute video displayed during the service",
      "1 month hosting",
      "Technical setup and pack-down",
      "Sydney metropolitan area",
    ],
    idealFor: "Families wanting a straightforward livestream without additional production.",
  },
  {
    name: "The Tribute",
    price: 1500,
    highlight: true,
    badge: "Most Popular",
    tagline: "A more polished livestream with multiple camera angles and better coverage.",
    inheritsFrom: "The Farewell",
    features: [
      "3 professional cameras",
      "Multiple camera angles",
      "Professional switching between cameras",
      "Dedicated audio recording",
      "Up to 1.5 hours",
      "Custom family viewing page",
      "Professional recording in Full HD",
      "Downloadable digital copy",
      "Basic technical backup system",
      "1 month hosting",
    ],
    idealFor: "Families who want the online experience to feel more like being there.",
  },
  {
    name: "The Legacy",
    price: 2500,
    highlight: false,
    tagline: "Premium funeral livestream and tribute production — a lasting visual record of the farewell.",
    inheritsFrom: "The Tribute",
    features: [
      "3 professional cameras",
      "Close-up, wide and audience coverage",
      "Professional wireless / venue audio integration",
      "Pre-service coverage (hearse arrival, hearse placement, family arrival and gathering)",
      "Post-service coverage (final goodbye, hearse departure)",
      "Drone coverage where permitted and conditions allow",
      "Custom branded / private family viewing page",
      "Memorial holding image featuring the deceased's photograph, name and years of birth and passing",
      "Up to 2 hours of coverage",
      "Separate high-quality audio recording",
      "3-minute professionally edited social media highlight video",
      "Music of your choice for the final edit",
      "Online delivery of the final recording and digital content",
      "Backup recording system",
      "Priority support",
      "3 month hosting",
    ],
    idealFor: "Families wanting more than a livestream — a lasting digital record that respectfully captures the farewell from the hearse arriving to the final goodbye.",
  },
];

const SYDNEY_COVERAGE_ADDONS = [
  {
    name: "The Home Farewell",
    price: 600,
    tagline: "A beautiful way to capture the final moments at home before the funeral.",
    features: [
      "Travel to the family home",
      "Film the hearse arriving",
      "Capture the family and loved ones gathering",
      "Capture the coffin being respectfully brought from the home",
      "Film the hearse departing",
      "Music of your choice for the final edit",
      "Delivered digitally to the family",
    ],
  },
  {
    name: "Burial Coverage — The Final Farewell",
    price: 600,
    tagline: "For families who would like the burial ceremony captured and livestreamed.",
    features: [
      "2 professional cameras",
      "Live streaming from the graveside",
      "Multi-camera coverage",
      "Professional audio",
      "Full burial ceremony recording",
      "Private family viewing link",
      "Full HD recording",
      "Digital delivery",
    ],
  },
];

const SYDNEY_AREAS = [
  "Sydney CBD", "Parramatta", "Liverpool", "Fairfield", "Blacktown", "Penrith",
  "Campbelltown", "Camden", "Bankstown", "Western Sydney", "South-West Sydney",
  "Inner West", "Eastern Suburbs", "North Sydney", "Northern Beaches",
  "Hills District", "Sutherland Shire",
];

export default function FuneralServicesSydney() {
  return (
    <FuneralLandingPage
      city="Sydney"
      citySlug="funeral-services-sydney"
      packages={SYDNEY_PACKAGES}
      coverageAddons={SYDNEY_COVERAGE_ADDONS}
      areas={SYDNEY_AREAS}
    />
  );
}
